<template>
	<div class="technologies">
		<div class="technologies__item_cnt" :class="[oneLine ? 'technologies__item_cnt--one_line' : '']">
			<htmlIcon :width="100"/>
		</div>
		<div class="technologies__item_cnt" :class="[oneLine ? 'technologies__item_cnt--one_line' : '']">
			<js :width="100"/>
		</div>
		<div class="technologies__item_cnt" :class="[oneLine ? 'technologies__item_cnt--one_line' : '']">
			<vueIcon :width="100"/>
		</div>
		<div class="technologies__item_cnt" :class="[oneLine ? 'technologies__item_cnt--one_line' : '']">
			<WordPress :width="100"/>
		</div>
		<div class="technologies__item_cnt" :class="[oneLine ? 'technologies__item_cnt--one_line' : '']">
			<php :width="100"/>
		</div>
		<div class="technologies__item_cnt" :class="[oneLine ? 'technologies__item_cnt--one_line' : '']">
			<jquery :width="100"/>
		</div>
	</div>	
</template>
<script>
	import js from './svg_icons/js.vue';
	import htmlIcon from './svg_icons/htmlIcon.vue';
	import vueIcon from './svg_icons/vueIcon.vue';
	import WordPress from './svg_icons/WordPress.vue';
	import php from './svg_icons/php.vue';
	import jquery from './svg_icons/jquery.vue';
	export default {
		name: 'Technologies',
		components: {
			js,
			htmlIcon,
			vueIcon,
			WordPress,
			php,
			jquery
		},
		props:{
			oneLine: {
		      type: Boolean,
		      required: false,
		      default: false
		    }
		}
	}
</script>
<style lang="scss" scoped>
.technologies{
	margin-top: 40px;
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	&__item_cnt{
		padding: 20px;
		flex-basis: 25%;
		display: flex;
		justify-content: center;
		&--one_line{
			flex-basis: 16.66666666666667%;
		}
	}
}
</style>